import { ArrowDown, Check } from "lucide-react";
import { Reveal, Chapter } from "./Reveal";

const BEFORE = ["Enquiry", "WhatsApp", "Excel", "Supplier emails", "Manual calculation", "PDF quotation", "Follow-up", "Booking"];
const AFTER = ["Enquiry", "Inquiry Workspace", "Product Selection", "Package Builder", "Pricing Engine", "Branded Quote", "Customer", "Booking / Conversion"];

export default function BeforeAfter() {
  return (
    <section className="border-y border-sand bg-parch py-24 lg:py-28">
      <div className="container-x">
        <Reveal><Chapter index={8} label="The Shift" /></Reveal>
        <Reveal delay={0.08}>
          <h2 className="mt-8 max-w-2xl font-serif text-3xl leading-[1.15] tracking-tight text-ink sm:text-4xl lg:text-5xl">
            The DMC workflow, rewired.
          </h2>
        </Reveal>
        <div className="mt-12 grid grid-cols-1 gap-5 lg:grid-cols-2">
          <Reveal>
            <div className="h-full rounded-2xl border border-dashed border-stone2/30 bg-white/60 p-7" data-testid="workflow-before">
              <p className="font-mono text-[10px] font-bold uppercase tracking-[0.22em] text-stone2">Before Travel-Tek</p>
              <ol className="mt-5 space-y-0">
                {BEFORE.map((s, i) => (
                  <li key={s} className="flex flex-col items-start">
                    <span
                      className="rounded-lg border border-dashed border-stone2/30 bg-white px-3.5 py-2 text-xs font-medium text-stone2"
                      style={{ marginLeft: `${(i % 4) * 12}px` }}
                    >
                      {s}
                    </span>
                    {i < BEFORE.length - 1 && <ArrowDown className="my-1 h-3 w-3 text-stone2/35" style={{ marginLeft: `${(i % 4) * 12 + 16}px` }} />}
                  </li>
                ))}
              </ol>
              <p className="mt-5 text-xs font-semibold text-stone2">Fragmented — every step a different tool, a different version, a different thread.</p>
            </div>
          </Reveal>
          <Reveal delay={0.12}>
            <div className="grain relative h-full overflow-hidden rounded-2xl bg-ink p-7 text-paper" data-testid="workflow-after">
              <p className="font-mono text-[10px] font-bold uppercase tracking-[0.22em] text-terra">With Travel-Tek</p>
              <ol className="mt-5 space-y-0">
                {AFTER.map((s, i) => (
                  <li key={s} className="flex flex-col items-start">
                    <span className="flex items-center gap-2 rounded-lg border border-white/15 bg-white/5 px-3.5 py-2 text-xs font-semibold text-paper">
                      <Check className="h-3 w-3 text-terra" /> {s}
                    </span>
                    {i < AFTER.length - 1 && <span className="my-1 ml-[16px] h-3.5 w-px bg-terra/60" />}
                  </li>
                ))}
              </ol>
              <p className="mt-5 text-xs font-semibold text-terra">Structured and connected — one workspace, one version of the truth.</p>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
